// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Button from 'presentations/views/components/atoms/Button';
import {
  mediaMaxWithLayoutTheme,
  spacing,
  zIndex,
} from 'presentations/views/styles';
import {
  black,
  blackFix,
  gray01,
  gray04,
  gray05,
  white,
  whiteFix,
} from 'presentations/views/styles/color';

interface Props {
  className?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  onSubmit?: any;
  onCancel?: any;
  submitLabel?: string;
  cancelLabel?: string;
  color?: string;
  isLightColor?: boolean;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  return (
    <ButtonContainer className={props.className}>
      {props.onCancel && (
        <CancelButton
          isDisabled={props.isLoading}
          onClick={props.onCancel}
          size={'large'}
        >
          {props.cancelLabel || t('Cancel')}
        </CancelButton>
      )}
      <SubmitButton
        size={'large'}
        type="submit"
        color="primary"
        onClick={props.onSubmit}
        isDisabled={props.isDisabled}
        isLoading={props.isLoading}
        themeColor={props.color}
        isThemeColorLight={props.isLightColor}
      >
        {props.submitLabel || t('Submit')}
      </SubmitButton>
    </ButtonContainer>
  );
}

const ButtonContainer = styled.div`
  /* margin: 0 auto; */
  display: flex;
  justify-content: center;

  /* position: fixed; */
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${white};
  padding: ${spacing(20)} 0;
  /* margin: 0 ${spacing(24)}; */
  margin: 0;
  border-top: 1px solid ${gray05};
  z-index: ${zIndex(500)};
  ${(props) => mediaMaxWithLayoutTheme(props, 'smartphone')} {
    /* margin: 0 ${spacing(12)}; */
    margin: 0;
    padding: ${spacing(12)} 0;
  }
`;

const SubmitButton = styled(Button)<{
  themeColor?: string;
  isThemeColorLight?: boolean;
}>`
  width: 240px;
  margin-left: ${spacing(24)};
  :first-of-type {
    margin-left: 0;
  }
  background-color: ${(props) => props.themeColor || ''};
  color: ${(props) => (props.isThemeColorLight ? blackFix : whiteFix)};
  :hover {
    background-color: ${(props) => props.themeColor || ''};
    color: ${(props) => (props.isThemeColorLight ? blackFix : whiteFix)};
  }
  ${(props) => mediaMaxWithLayoutTheme(props, 'smartphone')} {
    width: 140px;
  }
`;
const CancelButton = styled(Button)`
  width: 240px;
  ${(props) => mediaMaxWithLayoutTheme(props, 'smartphone')} {
    width: 140px;
  }
`;
